
const monthsKMList = ["មករា", "កុម្ភៈ", "មីនា", "មេសា", "ឧសភា", "មិថុនា", "កក្កដា", "សីហា", "កញ្ញា", "តុលា", "វិច្ឆិកា", "ធ្នូ"];
const monthsList = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];

let get_api = () => {
	let hostname = String(location.hostname);
	if (hostname.includes("backoffice.sf-admin.net")) return "https://api.sf-admin.net/api/v1";
	if (hostname.includes("backoffice-dev.sf-admin.net")) return "https://api-dev.sf-admin.net/api/v1";
	return "https://api.sf-admin.net/api/v1";
	// return "http://localhost:81/api/v1";
}
let get_cdn = () => {
	let hostname = String(location.hostname);
	if (hostname.includes("backoffice.sf-admin.net")) return "https://cdn-sg.sf-api.net/";
	if (hostname.includes("backoffice-dev.sf-admin.net")) return "https://cdn-sg.sf-api.net/";
	return "https://cdn-sg.sf-api.net/";
}

const config = {
	api: get_api(),
	cdn: get_cdn(),
	datelify: (timestamp) => {
		let d = new Date(timestamp * 1000);
		let date = d.getDate();
		let month = d.getMonth();
		let year = d.getFullYear();
		let hour = d.getHours();
		let minute = d.getMinutes();

		let state = hour >= 12 ? "PM" : "AM";
		let paddingDate = date > 9 ? "" : "0";
		let paddingMinute = minute > 9 ? "" : "0";

		return [`${paddingDate}${date} ${monthsList[month]} ${year} · ${hour}:${paddingMinute}${minute}${state}`, `${paddingDate}${date} ${monthsKMList[month]} ${year} · ${hour}:${paddingMinute}${minute}${state}`]
	},
	orderlify: (number) => {
		let length = String(number).length;
		let padding = 6 - length;
		let zeroPadding = "";
		for (let i = 0; i < padding; i++) {
			zeroPadding += "0";
		}

		return zeroPadding + number;
	},
	timelify: (date) => {
		let oldDate = new Date(date * 1000);
		let currentDate = new Date();

		let seconds = (oldDate.getTime() - currentDate.getTime()) / 1000;

		if (seconds / 31536000 > 1) {
			let num = Math.floor(seconds / 31536000);
			return [num + " more years", "រយៈពេល " + num + " ឆ្នាំ"];

		} else if (seconds / 2592000 > 1) {
			let num = Math.floor(seconds / 2592000)
			return [num + " more months", "រយៈពេល " + num + " ខែ"];

		} else if (seconds / 86400 > 1) {
			let num = Math.floor(seconds / 86400);
			return [num + " more days", "រយៈពេល " + num + " ថ្ងៃ"];

		} else if (seconds / 3600 > 1) {
			let num = Math.floor(seconds / 3600);
			return [num + " more hours", "រយៈពេល " + num + " ម៉ោង"];

		} else if (seconds / 60 > 1) {
			let num = Math.floor(seconds / 60);
			return [num + " more minutes", "រយៈពេល " + num + " នាទី"];

		} else {
			return ["expired", "ផុតកំណត់"];
		}

	},

	getDuration(min) {
		min = parseInt(min);
		let h = parseInt(min / 60);

		let m = min - h * 60;

		return `${h}h ${m}m`;
	},
	expire(d) {
		console.log(d);
	},

	getAge: (date) => {
		let oldDate = new Date(date * 1000);
		let currentDate = new Date();

		let seconds = (currentDate.getTime() - oldDate.getTime()) / 1000;

		if (seconds / 31536000 > 1) {
			let num = Math.floor(seconds / 31536000);
			return [num + " years ago", num + " ឆ្នាំមុន"];

		} else if (seconds / 2592000 > 1) {
			let num = Math.floor(seconds / 2592000)
			return [num + " months ago", num + " ខែមុន"];

		} else if (seconds / 86400 > 1) {
			let num = Math.floor(seconds / 86400);
			return [num + " days ago", num + " ថ្ងៃមុន"];

		} else if (seconds / 3600 > 1) {
			let num = Math.floor(seconds / 3600);
			return [num + " hours ago", num + " ម៉ោងមុន"];

		} else if (seconds / 60 > 1) {
			let num = Math.floor(seconds / 60);
			return [num + " minutes ago", num + " នាទីមុន"];

		} else {
			return ["Just now", "ឥឡូវនេះ"];
		}

	},

	getCookie: (cname) => {
		var name = cname + "=";
		var decodedCookie = decodeURIComponent(document.cookie);
		var ca = decodedCookie.split(';');
		for (var i = 0; i < ca.length; i++) {
			var c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return "";
	},
	translate(text, lang = 0) {
		let translate = text.split("||");

		lang = lang < translate.length ? lang : 0;
		if (translate.length - 1 <= lang) return translate[lang];
		else return translate;
	},
	clearList(array, lang = 0) {
		let data = [];
		for (let i = 0; i < array.length; i++) {
			if (array[i].id == 1) continue;
			let name = String(array[i].name).split("||");
			lang = lang < name.length ? lang : 0;
			array[i].name = name[lang];
			data.push(array[i]);
		}
		return data;
	},
	translateList(array, lang = 0) {
		let data = [];
		for (let i = 0; i < array.length; i++) {
			array[i].name = String(array[i].name).split("||")[lang];
			data.push(array[i]);
		}
		return data;
	},
	get_usd(total) {
		return this.moneylify(total / 4000, "usd");
	},
	moneylify: (total, currency = "khr") => {
		total = Number(total);
		if (Number.isNaN(total)) total = 0;

		const isKHR = currency === "khr";
		const isUSD = currency === "usd";

		const sign = total < 0 ? "-" : "";
		total = Math.abs(total);

		const formatted = total.toLocaleString("en-US", {
			minimumFractionDigits: 0,
			maximumFractionDigits: 2,
		});

		return sign +
			(isUSD ? "$" : "") +
			formatted +
			(isKHR ? " ៛" : "");
	},
	getExpire(timestamp) {

		let currentDay = new Date();

		let left = Math.round((timestamp * 1000 - currentDay.getTime()) / (86400000))

		return {
			value: left < 0 ? "ផុតកំណត់" : "សល់ " + left + " ថ្ងៃ",
			total: left < 0 ? 0 : left
		}
		// if (left < 0) {
		// 	return "ផុតកំណត់";
		// } else {
		// 	return "សល់ " + left + " ថ្ងៃ";
		// }
	},
	base64decode: function (encoded) {
		return new Buffer(encoded, 'base64').toString('utf8')
	},
	isJWT: function (jwt) {
		let jwt_part = String(jwt).split(".");

		if (jwt_part.length !== 3) return { valid: false, data: {} };

		let data;
		try {
			data = JSON.parse(this.base64decode(jwt_part[1]));
		} catch (e) {
			return { valid: false, data: {} };
		}

		return { valid: true, data: data };
	},
	discountPrice(price, discount, type) {
		price = parseFloat(price);
		discount = parseFloat(discount);
		let discounted_price;
		if (type == 'p') {
			discounted_price = price - (price * discount / 100);
			discounted_price = discounted_price.toFixed(2);
			return discounted_price;
		} else if (type == 'm') {
			discounted_price = price - discount;
			if (discounted_price < 0) {
				discounted_price = 0;
			}
			return discounted_price;
		} else {
			return price;
		}
	},
	validateUsername(string) {
		let array = String(string).split(" ");
		return array.join("").toLocaleLowerCase().trim();
	},
	getProfileUrl: (id = 'noavailable') => {
		return `https://oneme.oss-ap-southeast-7.aliyuncs.com/qr/${id}.jpg`;
	},
	isEmail: (string) => {
		let regex = /^\s*[\w\-\+_]+(\.[\w\-\+_]+)*\@[\w\-\+_]+\.[\w\-\+_]+(\.[\w\-\+_]+)*\s*$/
		return regex.test(string)
	},
	isPhoneValid: (phoneNumber) => {
		phoneNumber = phoneNumber.trim();
		let newPhoneNumber = phoneNumber;
		if (phoneNumber.substring(0, 1) == '0' || phoneNumber.substring(0, 3) == '855' || phoneNumber.substring(0, 4) == '+855') {
			if (phoneNumber.substring(0, 3) == '855') {
				newPhoneNumber = "0" + phoneNumber.substring(3);
			}
			if (phoneNumber.substring(0, 4) == '+855') {
				newPhoneNumber = "0" + phoneNumber.substring(4);
			}

			if (newPhoneNumber.length <= 10 && newPhoneNumber.length >= 9) {
				if (newPhoneNumber.substring(1) == parseInt(newPhoneNumber.substring(1)) && parseInt(newPhoneNumber.substring(0, 3)) > 9 && parseInt(newPhoneNumber.substring(0, 3)) < 100) {
					return true;
				} else {
					return false;
				}
			} else {
				return false;
			}
		} else {
			return false;
		}
	},
	generate: function (length) {
		let allowedString = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789"
		let generated = "";
		for (let i = 0; i < parseInt(length); i++) {
			let random = Math.floor(Math.random() * allowedString.length)
			generated += allowedString[random]
		}
		return String(generated);
	},
	getGender(t) {
		if (t == "O") return ["Other", "ផ្សេងទៀត"];
		if (t == "F") return ["Female", "ស្រី"];
		if (t == "M") return ["Male", "ប្រុស"];
		return "Unknown";
	},
	getType(s) {
		if (s == "movie") return "ភាពយន្ត";
		if (s == "series") return "រឿងភាគ";

		return "មិនមាន";
	},
	getSubscription(s) {
		if (s == "rent") return "សម្រាប់ជួល";
		if (s == "member") return "សមាជិក";
		if (s == "free") return "ឥតគិតថ្លៃ";

		return "មិនមាន";
	},
	getQuality(s) {
		if (s == "cam") return "CAM";
		if (s == "sd") return "SD";
		if (s == "hd") return "HD";
		if (s == "fhd") return "FHD";

		return "មិនមាន";
	},
	getLanguage(s) {
		if (s == "km") return "ភាសាខ្មែរ";
		if (s == "en") return "ភាសាអង់គ្លេស";
		if (s == "th") return "ភាសាថៃ";
		if (s == "cn") return "ភាសាចិន";

		return "មិនមាន";
	},
	getProcessStatus(s) {
		if (s == "0") return "រង់ចាំបម្លែង";
		if (s == "2") return "កំពុងបម្លែង";
		if (s == "3") return "ចាប់ផ្តើមបម្លែង";
		if (s == "1") return "បម្លែងរួចរាល់";
		if (s == "4") return "មានបញ្ហា";

		return "មិនមាន";
	},
	getRole(s) {
		if (s == "admin") return "អ្នកគ្រប់គ្រងទូទៅ";
		if (s == "operation-admin") return "អ្នកគ្រប់គ្រងទូទៅ";
		if (s == "super-admin") return "អ្នកគ្រប់គ្រងជាន់ខ្ពស់";
		if (s == "payment-admin") return "អ្នកគ្រប់គ្រងប្រតិបត្តិការ";
		if (s == "film-admin") return "អ្នកគ្រប់គ្រងរឿង";
	},
	getPayment(s) {
		if (s == "rent") return "ការជួល";
		if (s == "topup") return "បញ្ចូលប្រាក់";
		if (s == "member") return "ការជាវសមាជិក";
	},
	getProvider(s) {
		if (s == "payway") return "Payway";
		if (s == "bakong") return "Bakong";
		if (s == "wallet") return "Wallet";
	},
	getPlatform(s) {
		if (s == "all") return "បង្ហាញទាំងអស់";
		if (s == "web") return "បង្ហាញតែ WEB";
		if (s == "mobile") return "បង្ហាញតែ APP";
		if (s == "none") return "មិនបង្ហាញ";
	},
	getStatus(s) {
		if (s == "1") return "ដំណើរការ";
		if (s == "0") return "មិនដំណើរការ";
		if (s == "pad") return "បានបង់ប្រាក់";
		if (s == "npd") return "មិនទាន់បង់ប្រាក់";
		if (s == "fin") return "បានបញ្ចប់";
		if (s == "nac") return "មិនដំណើរការ";
		if (s == "rcv") return "អ្នកទទួល";
		if (s == "snd") return "អ្នកផ្ញើរ";
		if (s == "ndv") return "មិនមានអ្នកដឹក";
		if (s == "wdv") return "រង់ចាំអ្នកដឹក";
		if (s == "dvr") return "កំពុងដឹកជញ្ជូន";
		if (s == "dlv") return "បានដល់អតិថិជន";
		if (s == "rtn") return "បានត្រឡប់";
		if (s == "sl") return "Accountant Administrator";
		if (s == "sa") return "Super Administrator";
		if (s == "ad") return "Operation Administrator";
		if (s == "ca") return "Call Center Administrator";
		return "មិនមាន";
	},
	month_km_list: ["មករា", "កុម្ភៈ", "មីនា", "មេសា", "ឧសភា", "មថុនា", "កក្កដា", "សីហា", "កញ្ញា", "តុលា", "វិច្ឆកា", "ធ្នូ"]
}


export default config;



// WEBPACK FOOTER //
// ./src/config/config.js